import './PartnerTariffs.css';
import api from '../api.js';
import { useEffect, useState } from "react";

import plus from "../imgs/plus.svg";
import edit from "../imgs/pen.svg";
import { fmtMoney } from '../utils/format';

export default function PartnerTariffs() {

    const [partnerTariffs, setPartnerTariffs] = useState([]);
    const [partners, setPartners] = useState([]);
    const [tariffs, setTariffs] = useState([]);

    const [loading, setLoading] = useState(true);

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const [selectedPartner, setSelectedPartner] = useState("");
    const [selectedTariff, setSelectedTariff] = useState("");
    const [price, setPrice] = useState("");

    const [processing, setProcessing] = useState(false);

    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const [filteredPartner, setFilteredPartner] = useState("");
    const [filteredTariff, setFilteredTariff] = useState("");

    const [filteredActive, setFilteredActive] = useState("");

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editingTariff, setEditingTariff] = useState(null);
    const [editPrice, setEditPrice] = useState("");
    const [editProcessing, setEditProcessing] = useState(false);
    const [editMessage, setEditMessage] = useState("");
    const [editError, setEditError] = useState("");
    const [priceChanged, setPriceChanged] = useState(false);

    const [toggleError, setToggleError] = useState("");
    const [loadError, setLoadError] = useState("");

    useEffect(() => {
        document.title = "Тарифы партнера- Wave";
        loadData();
    }, []);

    const filteredPartnerTariffs = partnerTariffs.filter((item) => {

        const partnerMatch =
            !filteredPartner ||
            item.partner === filteredPartner;

        const tariffMatch =
            !filteredTariff ||
            item.category === filteredTariff;

        const activeMatch =
            filteredActive === ""
                ? true
                : String(item.isActive) === filteredActive;

        return (
            partnerMatch &&
            tariffMatch &&
            activeMatch
        );
    });

    async function loadData() {
        try {
            const [
                tariffsRes,
                partnersRes,
                partnerTariffsRes
            ] = await Promise.all([
                api.get('/api/tariffs/get-all-tariffs'),
                api.get('/api/partners/list'),
                api.get('/api/tariffs/get-all-partner-tariffs')
            ]);

            setTariffs(tariffsRes.data);
            setPartners(partnersRes.data);
            setPartnerTariffs(partnerTariffsRes.data);

        } catch (err) {
            setLoadError("Ошибка загрузки данных");
        } finally {
            setLoading(false);
        }
    }

    const closeCreateModal = () => {
        setIsCreateModalOpen(false);

        setSelectedPartner("");
        setSelectedTariff("");
        setPrice("");

        setMessage("");
        setError("");
    };

    const handleCreatePartnerTariff = async (e) => {
        e.preventDefault();

        setProcessing(true);
        setMessage("");
        setError("");

        try {
            const res = await api.post(
                '/api/tariffs/create-partner-tariff',
                {
                    partnerName: selectedPartner,
                    category: selectedTariff,
                    price: Number(price)
                }
            );

            if (res.status === 200) {
                setMessage("Тариф успешно создан");

                await loadData();

                setSelectedPartner("");
                setSelectedTariff("");
                setPrice("");
            }

        } catch (err) {

            const errorData = err?.response?.data;

            if (typeof errorData === "string") {
                setError(errorData);
            } else if (errorData?.errors) {
                const firstError = Object.values(errorData.errors)[0];
                setError(
                    Array.isArray(firstError)
                        ? firstError[0]
                        : "Ошибка валидации"
                );
            } else {
                setError("Ошибка при создании тарифа");
            }

        } finally {
            setProcessing(false);
        }
    };

    const openEditModal = (item) => {
        setEditingTariff(item);
        setEditPrice(String(item.price));
        setEditMessage("");
        setEditError("");
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setEditingTariff(null);
        setEditPrice("");
        setEditMessage("");
        setEditError("");
    };

    const handleEditPartnerTariff = async (e) => {
        e.preventDefault();
        setEditError("");
        setEditMessage("");


        if (priceChanged) {

            if (Number(editPrice) <= 0) {
                setEditError("Цена должна быть больше нуля");
                return;
            }

            setEditProcessing(true);
            setEditMessage("");
            setEditError("");


            try {
                const res = await api.patch('/api/tariffs/edit-partner-tariff', {
                    id: editingTariff.id,
                    price: Number(editPrice)
                });

                if (res.status === 200) {
                    setEditMessage("Тариф успешно обновлён");

                    setPartnerTariffs(prev =>
                        prev.map(t =>
                            t.id === editingTariff.id ? { ...t, price: Number(editPrice) } : t
                        )
                    );
                }
            } catch (err) {
                const errorData = err?.response?.data;
                setEditError(typeof errorData === "string" ? errorData : "Ошибка при редактировании тарифа");
            } finally {
                setEditProcessing(false);
            }
        }

        setPriceChanged(false);
    };

    const handleToggleActive = async (item) => {
        setToggleError("");
        try {
            await api.patch('/api/tariffs/toggle-partner-tariff', null, {
                params: { id: item.id }
            });
            setPartnerTariffs(prev =>
                prev.map(t =>
                    t.id === item.id ? { ...t, isActive: !t.isActive } : t
                )
            );
        } catch (err) {
            setToggleError("Ошибка при изменении статуса тарифа");
        }
    };
    return (
        <div className="partner-tariffs-main">

            <div className='partner-tariffs-top'>
                <button
                    className='createTariff'
                    onClick={() => setIsCreateModalOpen(true)}
                >
                    <p>Создать тариф</p>
                    <img src={plus} alt="plus" />
                </button>
            </div>

            <form className="partner-tariffs-filter">
                <div className="filters-row">

                    <label>
                        Партнер:
                        <select
                            value={filteredPartner}
                            onChange={(e) => setFilteredPartner(e.target.value)}
                        >
                            <option value="">Все</option>

                            {partners.map((partner) => (
                                <option key={partner.id} value={partner.name}>
                                    {partner.name}
                                </option>
                            ))}
                        </select>
                    </label>

                    <label>
                        Тариф:
                        <select
                            value={filteredTariff}
                            onChange={(e) => setFilteredTariff(e.target.value)}
                        >
                            <option value="">Все</option>

                            {tariffs.map((tariff, index) => (
                                <option key={index} value={tariff}>
                                    {tariff}
                                </option>
                            ))}
                        </select>
                    </label>
                    <label>
                        Активность:

                        <select
                            value={filteredActive}
                            onChange={(e) =>
                                setFilteredActive(e.target.value)
                            }
                        >
                            <option value="">
                                Все
                            </option>

                            <option value="true">
                                Активные
                            </option>

                            <option value="false">
                                Деактивированные
                            </option>
                        </select>
                    </label>

                </div>
            </form>

            {loadError && <p className="error">{loadError}</p>}
            {toggleError && <p className="error">{toggleError}</p>}

            <div className='partner-tariffs-table-wrapper'>
                <table className="partner-tariffs-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Партнер</th>
                            <th>Тариф</th>
                            <th>Цена</th>
                            <th>Активен</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}>
                                    Загрузка...
                                </td>
                            </tr>
                        ) : filteredPartnerTariffs.length > 0 ? (

                            filteredPartnerTariffs.map((item, index) => (
                                <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>{item.partner}</td>
                                    <td>{item.category}</td>
                                    <td className="num">{fmtMoney(item.price)}</td>
                                    <td>
                                        <button
                                            className={item.isActive ? "status-button" : "status-button-disabled"}
                                            onClick={() => handleToggleActive(item)}
                                            onMouseEnter={e => { if (item.isActive) e.currentTarget.innerText = "Деактивировать"; if (!item.isActive) e.currentTarget.innerText = "Активировать" }}
                                            onMouseLeave={e => { if (item.isActive) e.currentTarget.innerText = "Активен"; if(!item.isActive) e.currentTarget.innerText = "Деактивирован" }}
                                        >
                                            {item.isActive ? "Активен" : "Деактивирован"}
                                        </button>
                                    </td>
                                    <td>
                                        {item.isActive && <>
                                            <button className='edit-btn' onClick={() => openEditModal(item)}>Редактировать</button>
                                            <button className='edit-btn-mobile' onClick={() => openEditModal(item)}><img src={edit} alt="edit" /></button>
                                        </>
                                        }
                                    </td>
                                </tr>
                            ))

                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", color: "red" }}>
                                    Тарифы не найдены
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {isCreateModalOpen && (
                <div className="modalOverlay">
                    <div className="modalPartnersTariffs">
                        <form onSubmit={handleCreatePartnerTariff}>

                            <div className='modalTop'>
                                <h3>Создать тариф</h3>
                                <button
                                    type="button"
                                    onClick={closeCreateModal}
                                />
                            </div>

                            <select
                                required
                                value={selectedPartner}
                                onChange={(e) => setSelectedPartner(e.target.value)}
                            >
                                <option value="">Выберите партнера</option>

                                {partners.map((partner) => (
                                    <option key={partner.id} value={partner.name}>
                                        {partner.name}
                                    </option>
                                ))}
                            </select>

                            <select
                                required
                                value={selectedTariff}
                                onChange={(e) => setSelectedTariff(e.target.value)}
                            >
                                <option value="">Выберите тариф</option>

                                {tariffs.map((tariff, index) => (
                                    <option key={index} value={tariff}>
                                        {tariff}
                                    </option>
                                ))}
                            </select>

                            <input
                                required
                                type="number"
                                placeholder='Цена'
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                            />

                            {message && (
                                <p className="success">{message}</p>
                            )}

                            {error && (
                                <p className="error">{error}</p>
                            )}

                            <div className='buttonsModal'>
                                <button
                                    disabled={processing}
                                    type="submit"
                                    className='saveChangesPartners'
                                >
                                    Создать тариф
                                </button>

                                <button
                                    disabled={processing}
                                    type="button"
                                    className='cancelPartners'
                                    onClick={closeCreateModal}
                                >
                                    Отмена
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            )}

            {isEditModalOpen && editingTariff && (
                <div className="modalOverlay">
                    <div className="modalPartnersTariffs">
                        <form onSubmit={handleEditPartnerTariff}>
                            <div className='modalTop'>
                                <h3>Редактировать тариф</h3>
                                <button type="button" onClick={closeEditModal} />
                            </div>
                            <input disabled value={editingTariff.partner} />
                            <input disabled value={editingTariff.category} />
                            <input
                                required
                                type="number"
                                placeholder='Цена'
                                value={editPrice}
                                onChange={(e) => { setEditPrice(e.target.value); setPriceChanged(true) }}
                            />
                            {editMessage && <p className="success">{editMessage}</p>}
                            {editError && <p className="error">{editError}</p>}
                            <div className='buttonsModal'>
                                <button disabled={editProcessing} type="submit" className='saveChangesPartners'>
                                    Сохранить
                                </button>
                                <button disabled={editProcessing} type="button" className='cancelPartners' onClick={closeEditModal}>
                                    Отмена
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}
